import { map, filter, switchMap } from 'rxjs/operators';
import { Observable, of, from } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { EpicDependencies } from '../../dependencies.interface';
import { validateDefaultValue } from '../../validations';
import {
  DefaultValue,
  VariablesEditorDialogAction,
  SET_DEFAULT_VALUE,
  createSetDefaultValueValidation,
} from '../../actions';
import { State } from '../../state.interface';
import { ValidateEditableImage } from '../../validations/validate-editable-image/validate-editable-image';

export const createSetDefaultValueValidationOnChange =
  (validateEditableImage: ValidateEditableImage) =>
  (
    actions$: Observable<VariablesEditorDialogAction>,
    state$: StateObservable<State>,
    _dependencies: EpicDependencies,
  ): Observable<any> =>
    actions$.pipe(
      filter(() => state$.value.useEditableImage),
      ofType(SET_DEFAULT_VALUE),
      switchMap((action: DefaultValue) => {
        const state = state$.value;
        if (state.variableConfiguration.type === 'image') {
          return from(validateEditableImage(action.payload.defaultValue, state.translations.validationErrors));
        }
        return of(validateDefaultValue(action.payload.defaultValue, state.translations.validationErrors));
      }),
      map(({ isInvalid, errorMessage }) => createSetDefaultValueValidation(isInvalid, errorMessage)),
    );
